import React, { useRef, useState, useEffect } from 'react';
import { Upload, X, Loader, FileText } from 'lucide-react';
import { adminApi, fileUrl } from '../../api/client';

function fileName(path) {
  if (!path) return '';
  return path.split('/').pop() || path;
}

function isImage(path) {
  if (!path) return false;
  return /\.(jpg|jpeg|png|webp|gif)$/i.test(path);
}

export default function FileUpload({ value, onChange, accept = '.pdf,.doc,.docx,image/*', uploadApi = adminApi.uploadFile }) {
  const [busy, setBusy] = useState(false);
  const [name, setName] = useState(fileName(value));
  const [localUrl, setLocalUrl] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    setName(fileName(value));
    setLocalUrl(null);
  }, [value]);

  const handleFile = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const isImageFile = file.type.startsWith('image/');
      const objectUrl = URL.createObjectURL(file);
      setName(file.name);
      setLocalUrl(isImageFile ? objectUrl : null);
      const res = await uploadApi(file);
      if (res.url) {
        onChange?.(res.url);
        setName(fileName(res.url) || file.name);
      } else {
        onChange?.(objectUrl);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setBusy(false);
    }
  };

  const handleChange = (e) => {
    const [file] = e.target.files;
    handleFile(file);
  };

  const clear = () => {
    setName('');
    setLocalUrl(null);
    onChange?.('');
    if (inputRef.current) inputRef.current.value = '';
  };

  const imageSrc = localUrl || (isImage(value) ? fileUrl(value) : null);

  return (
    <div className="file-upload">
      <input
        id="file-upload-input"
        type="file"
        ref={inputRef}
        accept={accept}
        onChange={handleChange}
        style={{ display: 'none' }}
      />

      {!name ? (
        <label
          htmlFor="file-upload-input"
          className="photo-upload-zone"
          aria-label="Choisir un fichier"
        >
          {busy ? <Loader size={16} className="spin" /> : <Upload size={16} />}
          {busy ? 'Chargement…' : 'Cliquer pour ajouter un fichier'}
        </label>
      ) : (
        <div className="file-upload-preview">
          {imageSrc ? (
            <img
              src={imageSrc}
              alt="Aperçu du document"
              style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 8 }}
            />
          ) : (
            <FileText size={28} color="var(--teal)" />
          )}
          <a href={fileUrl(value) || '#'} target="_blank" rel="noreferrer">
            {name}
          </a>
          <button type="button" onClick={clear} aria-label="Supprimer">
            <X size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
